import React from "react"
import { Outlet } from "react-router-dom";
import classes from "./KegelApp.module.css";
import KegelAppNavigation from "./KegelAppNavigation";

function KegelAppRootLayout() {
    return (
        <div className={`container ${classes.kegel_container}`}>
            <KegelAppNavigation />
            <section>
                <div className={classes.kegel_contents}>
                    <Outlet />
                </div>
            </section>
        </div>
    );
}

export default KegelAppRootLayout;
